// extracted by mini-css-extract-plugin
export default {"cls1":"ToolsMenu-cls1_L76","cls2":"ToolsMenu-cls2_pbi ToolsMenu-cls1_L76"};